/** @format */
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { TimelineControlsService } from '../service/timeline-controls.service';

@Component({
    selector: 'app-show-summer-period-checkbox',
    standalone: false,
    templateUrl: './show-summer-period-checkbox.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowSummerPeriodCheckboxComponent {
    private readonly timelineControlsService = inject(TimelineControlsService);

    isChecked$: Observable<boolean> = this.timelineControlsService.showEmptySummerPeriods$;

    setShowSummerPeriod(value: boolean) {
        this.timelineControlsService.setShowEmptySummerPeriods(value);
    }
}
